export default "__VITE_ASSET__7d6d9109__"